import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Spinner } from '@/components/app';
import { UserDetail } from '@/common/models/UserDetail';
import { PaginationHelper } from '@/common/helpers';
import UserDetailsRole from '@/common/models/UserDetailsRole';
import { Pagination } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Spinner,
    Pagination,
  },
})
export default class UserDetailsList extends Vue {
  readonly pageSizeOptions: string[] = ['50', '100', '200'];

  @Prop({ required: true }) userDetails?: UserDetail;
  @Prop({ required: true }) currentPage!: number;
  @Prop() loading?: boolean;

  pageSize: number = 50;

  headers: any = [
    { text: 'Access to', value: 'scope' },
    { text: 'Role', value: 'role' },
    { text: 'Role assignment', value: 'type' },
  ];

  get totalRows(): number {
    return this.userDetails!.roles! ? this.userDetails!.roles!.length : 0;
  }

  get items(): UserDetailsRole[] {
    return this.userDetails && this.userDetails.roles ? this.userDetails.roles : [];
  }

  get pages(): number {
    return PaginationHelper.pages(this.items, this.pageSize);
  }

  get showPagination(): boolean {
    return PaginationHelper.showPagination(this.items, this.pageSizeOptions);
  }

  get canPrevious(): boolean {
    return PaginationHelper.canPrevious(this.currentPage);
  }

  get canNext(): boolean {
    return PaginationHelper.canNext(this.currentPage, this.pages);
  }

  pageSizeChange(pageSize: number): void {
    this.pageSize = pageSize;
  }

  @Emit()
  pageChange(pageNumber: number): void {
    this.$emit('pageChange', pageNumber);
  }

}
